import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { StockProductService } from '../../../../services/stock-product.service';
import { GlobalVariable } from '../../../../helpers/settings';
import { User } from '../../../../models/user';
import { Role } from '../../../../models/user-role';
import { UserService } from '../../../../services/user.service';
import { RoleService } from '../../../../services/user-role.service';
import { ProjectService } from '../../../../services/project.service';
import { Project } from '../../../../models/project';

@Component({
	selector: 'app-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
	public globalStockInfo = GlobalVariable['STOCK'];
	public openNotification: boolean = false;
	public isLoading = false;
	public notifications = [];
	public projects: Project[] = [];
	public currentUser: Partial<User> = {
		username: null,
		email: null,
		firstName: null,
		roles: [],
		userRole: { role: null },
		salary: null,
		lastName: null,
		phoneNumber: null,
		address: null,
		password: null,
		imageUrl: null,
		city: null,
		active: true,
		project: null
	};
	public currentUserRole: Partial<Role> = {
		name: null,
		access: []
	};
	constructor(
		private el: ElementRef,
		private stockLineService: StockProductService,
		private userService: UserService,
		private roleService: RoleService,
		private projectService: ProjectService
	) {}

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUserInfos();
		if (this.currentUser?.roles?.some(role => role === 'User')) {
			this.currentUserRole = this.currentUser?.userRole?.role as Role;
		}
		this.projectService
			.find(false, true, false, null, null, 'notifications', null, 'find projects')
			.subscribe(res => {
				this.projects = res;
				if (this.currentUser?.roles?.some(role => role === 'User')) {
					for (let project of this.projects) {
						const hasAuthorizationToProject = this.roleService.getAuthorizationProjectComponent(
							this.currentUserRole,
							project._id,
							this.globalStockInfo?.route,
							null
						);
						if (hasAuthorizationToProject) {
							this.stockLineService.getNotificationByProject(project._id).subscribe(data => {
								this.notifications = this.notifications.concat(data);
							});
						}
					}
				}
				if (this.roleService.hasOwnerAccess()) {
					this.stockLineService.getNotification().subscribe(data => {
						this.notifications = data;
					});
				}
			});
	}

	toggleNotificationMobile() {
		this.openNotification = !this.openNotification;
	}
	@HostListener('document:click', ['$event'])
	onClickOutside(event: MouseEvent) {
		if (!this.el.nativeElement.contains(event.target)) {
			this.openNotification = false;
		}
	}
}
